import { render } from "./CollectionCardPartner.vue?vue&type=template&id=8733eb16"
import script from "./CollectionCardPartner.vue?vue&type=script&lang=js"
export * from "./CollectionCardPartner.vue?vue&type=script&lang=js"

import "./CollectionCardPartner.vue?vue&type=style&index=0&id=8733eb16&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__